import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type {
  InterviewScheduleLink,
  InterviewScheduleLinkReferences,
} from '@core/interview-schedules-types';

@Injectable({ providedIn: 'root' })
export class InterviewSchedulesLinkEntityHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(id: number): Observable<{
    interviewSchedule: InterviewScheduleLink;
    references: InterviewScheduleLinkReferences[];
  }> {
    return this.httpApi.get(`interview/schedules/${id}`);
  }

  public update(data: Partial<InterviewScheduleLink>): Observable<{
    interviewSchedule: InterviewScheduleLink;
    references: InterviewScheduleLinkReferences[];
  }> {
    const body = { interview_schedule: data };

    if (data.id) {
      return this.httpApi.patch(`interview/schedules/${data.id}`, null, body);
    } else {
      return this.httpApi.post(`interview/schedules`, null, body);
    }
  }

  public delete(id: number): Observable<InterviewScheduleLink> {
    return this.httpApi
      .delete(`interview/schedules/${id}`)
      .pipe(map(_data => _data.interviewSchedule));
  }

  public fetchDuplicateName(id: number): Observable<string> {
    return this.httpApi
      .get(`interview/schedules/${id}/next_duplicate_name`)
      .pipe(map(data => data.nextDuplicateName));
  }
}
